import { useParams } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import useAccessToken, { accessToken } from "../../../hooks/useAccessToken.js"
import useConfig from "../../../hooks/useConfig"

import { UserRoles, UserTypes } from "../../../utils/constants.js"
import { NotificationTypes, addNotification } from "../../../stores/notification-store.js"
import { addRole, addUsers } from "../../../utils/api.js"

import { RegularExpressions } from '../../../utils/RegularExpressions'
import { naturalValidateInput, validateForm, validateInput } from '../../../utils/utils'

function NewUserModal({ showSignal }) {

	const { beId } = useParams()
	const { config } = useConfig()
	useAccessToken()

	const usernameErrorSignal = useSignal(true)
	const firstNameErrorSignal = useSignal(true)
	const lastNameErrorSignal = useSignal(true)
	const emailErrorSignal = useSignal(true)
	const verifyEmailErrorSignal = useSignal(true)

	const disableSubmitButtonComputed = useComputed(
		() => {
			let print = true
			if(print){
				if(usernameErrorSignal.value){
					console.log("Username has an error")
				}
				else{
					console.log("Username passes")
				}
				if(firstNameErrorSignal.value){
					console.log("First name has an error")
				}
				else{
					console.log("First name passes")
				}
				if(lastNameErrorSignal.value){
					console.log("Last name has an error")
				}
				else{
					console.log("Last name passes")
				}
				if(emailErrorSignal.value){
					console.log("Email address has an error")
				}
				else{
					console.log("Email address passes")
				}
				if(verifyEmailErrorSignal.value){
					console.log("Verify email address has an error")
				}
				else{
					console.log("Verify emaill address passes")
				}
			}
			return usernameErrorSignal.value || firstNameErrorSignal.value || lastNameErrorSignal.value || emailErrorSignal.value || verifyEmailErrorSignal.value || userRoleSignal.value == null
		}
	)

	let userRoleSignal = useSignal(null)

	const setRoleId = function (event) {
		let target = event.target
		userRoleSignal.value = parseInt(target.value)
	}

	const validators = {
		naturalValidateInput: naturalValidateInput,
		validateUsername: (input) => {
			const userNameRegex = /^[a-zA-Z0-9_@.+-]+$/
			if (!userNameRegex.test(input.value)) {
				usernameErrorSignal.value = input.getAttribute("data-msg")
				console.log(usernameErrorSignal.value)
				throw new Error(usernameErrorSignal.value)
			}
			else{
				usernameErrorSignal.value = null
			}
			return true
		},
		validateFirstName: (input) => {
			const firstNameRegex = /^[a-zA-Z0-9!.' -]+$/
			if (!firstNameRegex.test(input.value)) {
				firstNameErrorSignal.value = input.getAttribute("data-msg")
				console.log(firstNameErrorSignal.value)
				throw new Error(firstNameErrorSignal.value)
			}
			else{
				firstNameErrorSignal.value = null
			}
			return true
		},
		validateLastName: (input) => {
			const lastNameRegex = /^[a-zA-Z!. '-]+$/
			if (!lastNameRegex.test(input.value)) {
				lastNameErrorSignal.value = input.getAttribute("data-msg")
				console.log(lastNameErrorSignal.value)
				throw new Error(lastNameErrorSignal.value)
			}
			else{
				lastNameErrorSignal.value = null
			}
			return true
		},
		validateEmailAddress: (input) => {
			const emailRegex = RegularExpressions.ValidEmailAddress
			if (!emailRegex.test(input.value)) {
				emailErrorSignal.value = input.getAttribute("data-msg")
				console.log(emailErrorSignal.value)
				throw new Error(emailErrorSignal.value)
			}
			else{
				emailErrorSignal.value = null
			}
			return true
		},
		validateVerifyEmailAddress: (input) => {
			const emailAddress = document.getElementById("userForm_emailAddress").value
			const verifyEmailAddress = input.value
			console.log("Email address: ".concat(emailAddress))
			console.log("Verify email address: ".concat(verifyEmailAddress))
			if (emailAddress !== verifyEmailAddress) {
				verifyEmailErrorSignal.value = input.getAttribute("data-msg")
				console.log(verifyEmailErrorSignal.value)
				throw new Error(verifyEmailErrorSignal.value)
			}
			else{
				//console.log("Both email addresses match")
				verifyEmailErrorSignal.value = null
			}
			return true
		}
	}

	const assembleUserData = (form) => {
		let entity = {}
		//console.log("Received a form with the following elements:")
		for(let i = 0; i < form.elements.length; i++){
			const element = form.elements[i]
			//console.log(element)
			if(element.name && element.name.length && element.name.length > 0 && element.type){
				if(element.type == "radio"){
					if(element.checked == true){
						entity[element.name] = element.value
					}
				}
				else if(element.type == "checkbox"){
					entity[element.name] = element.checked == true
				}
				else{
					entity[element.name] = element.value
					//console.log("Assigned value ".concat(element.value).concat(" to entity field ").concat(element.name))
				}
			}
		}
		entity.BusinessEntityId = beId,
		entity.UserType = UserTypes.Standard
		entity.IsActive = true
		delete entity.role
		// This crazy object seems to be required by the security rest api
		/*entity["__identity"] = {
			"__identity": {
				"__identity": null
			}
		}*/
		console.log(entity)
		return entity
	}

	const validate = async (event) => {
		assembleUserData(event.target.form)
		return await validateInput(event.target, validators, event.type)
	}

	const submitForm = async function(event) {
		event.preventDefault()
		const form = event.target.form
		if (validateForm(form, validators)) {
			try {
				const user = assembleUserData(form)
				console.log("About to submit the following user data:")
				console.log(user)
				const newUserResult = await addUsers(beId, user, config.value, accessToken.value)
				if (typeof newUserResult === 'object' && typeof newUserResult.id != 'undefined') {
					console.log(newUserResult)
					const userId = newUserResult.id
					console.log(beId)
					await addRole(beId, userId, userRoleSignal.value, [beId], config.value, accessToken.value)

					addNotification("User " + user.FirstName + ' ' + user.LastName + ' added', NotificationTypes.SUCCESS, true)
				} else {
					console.error(newUserResult)
					throw new Error("Unknown error")
				}
				cancelAdd()
			} catch (errorDetails) {
				console.error("API Error:", errorDetails.toString());
				addNotification('Unable to add the user: ' + errorDetails.toString(), NotificationTypes.ERROR, true)
			}
		}
		else{
			console.log("Form validation failed")
		}
		return false
	}

	const cancelAdd = function () {
		showSignal.value = false
	}

	return (
		<Modal
			show = { showSignal.value }
			onHide = { cancelAdd }
			backdrop = "static"
			size={'xl'}
		>
			<Modal.Header closeButton className="panel-heading">
				<Modal.Title className="panel-title">Add new user</Modal.Title>
			</Modal.Header>
			<Form id='userForm' className="form-horizontal newvalidation" role="form" spellCheck="false" autoComplete="off" autoCapitalize="off" autoCorrect="off">

				<Modal.Body className="panel-body">
					<div id='form-container'>
						<Form.Group className="form-group">
							<label htmlFor='userName' className='col-md-2 control-label'>Username</label>
							<div className='col-md-10'>
								<Form.Control 
									/*type='text'*/ 
									className="form-control username" 
									name='Username' 
									maxLength='50' 
									required={true} 
									onChange={validate} 
									onKeyUp={validate} 
									data-validators={JSON.stringify({
										change:["validateUsername"], 
										keyup:["validateUsername"]
									})} 
									data-msg="Username must be between 1 and 50 valid characters: A-Z, a-z, 0-9, period (.), underscore (_), hyphen (-), or at-sign(@)." 
								/>
							</div>
						</Form.Group>
						<Form.Group className="form-group">
							<label htmlFor='fname' className='col-md-2 control-label'>First Name</label>
							<div className='col-md-10'>
								<Form.Control 
									type='text' 
									className="form-control person" 
									name='FirstName' 
									maxLength='50' 
									required={true} 
									onChange={validate}
									onKeyUp={validate} 
									data-validators={JSON.stringify({
										change:["validateFirstName"], 
										keyup:["validateFirstName"]
									})} 
									data-msg="First name must be between 1 and 50 valid characters: 0-9, A-Z, a-z, exclamation point (!), period (.), hyphen (-), space ( ), or apostrophe (')." 
								/>
							</div>
						</Form.Group>
						<Form.Group className="form-group">
							<label htmlFor='lname' className='col-md-2 control-label'>Last Name</label>
							<div className='col-md-10'>
								<Form.Control 
									type='text' 
									className="form-control person" 
									name='LastName' 
									maxLength='50' 
									required={true} 
									onChange={validate}
									onKeyUp={validate} 
									data-validators={JSON.stringify({
										change:["validateLastName"], 
										keyup:["validateLastName"]
									})} 
									data-msg="Last name must be between 1 and 50 valid characters: A-Z, a-z, exclamation point (!), period (.), hyphen (-), space ( ), or apostrophe (')." 
								/>
							</div>
						</Form.Group>
						<Form.Group className="form-group">
							<label htmlFor='newEmail' className='col-md-2 control-label'>Email Address</label>
							<div className='col-md-10'>
								<Form.Control 
									type='email' 
									placeholder='sample@email.com' 
									className="form-control email" 
									name='Email' 
									id="userForm_emailAddress"
									maxLength='200' 
									required={true} 
									onChange={validate}
									onKeyUp={validate} 
									data-validators={JSON.stringify({
										change:["validateEmailAddress"], 
										keyup:["validateEmailAddress"]
									})} 
									data-msg='Invalid email address format.' 
								/>
							</div>
						</Form.Group>
						<Form.Group className="form-group">
							<label htmlFor='verifyEmail' className='col-md-2 control-label'>Verify Email</label>
							<div className='col-md-10'>
								<Form.Control 
									type='email' 
									className="form-control email" 
									maxLength='200' 
									required={true} 
									onChange={validate}
									onKeyUp={validate} 
									data-validators={JSON.stringify({
										change:["validateVerifyEmailAddress"], 
										keyup:["validateVerifyEmailAddress"]
									})} 
									data-msg='Email addresses do not match.' 
								/>
							</div>
						</Form.Group>
						<Form.Group className="form-group">
							<div className='col-md-2 control-label'>Role</div>
							<div className='col-md-10'>
								<Form.Check type="radio" name="role" value={UserRoles.ReadOnly} onChange={setRoleId} label="Read Only"></Form.Check>
								<Form.Check type="radio" name="role" value={UserRoles.Manager} onChange={setRoleId} label="Manager"></Form.Check>
								<Form.Check type="radio" name="role" value={UserRoles.TechnicalAdvisor} onChange={setRoleId} label="Technical Advisor"></Form.Check>
								<Form.Check type="radio" name="role" value={UserRoles.Technician} onChange={setRoleId} label="Technician"></Form.Check>
								<Form.Check type="radio" name="role" value={UserRoles.HelpDesk} onChange={setRoleId} label="Help Desk Administrator"></Form.Check>
							</div>
						</Form.Group>
					</div>
				</Modal.Body>
				<Modal.Footer className="panel-footer col-xs-12">
					<div className='pull-right'>
						<Button className="btn btn-md btn-default" style={{ marginRight: '1rem' }} onClick={cancelAdd}>Cancel</Button>
						<button className="btn btn-md btn-primary" disabled={disableSubmitButtonComputed.value ? "disabled" : undefined} onClick={submitForm}>Add</button>
					</div>
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default NewUserModal